<div class="file-display-wrapper">
  <!-- Add file size indicator -->
  <div *ngIf="currentFiles?.length + currentFixedFiles?.length > 0 && !isAlreadySent" class="file-size-indicator">
    <div class="progress-bar">
      <div class="progress-fill" [style.width.%]="usedPercentage" 
           [class.warning]="usedPercentage > 70 && usedPercentage < 90"
           [class.error]="usedPercentage >= 90"></div>
    </div>
    <div class="size-text" [class.error-text]="!isValid">
      {{ formattedTotalSize }} / {{ maxTotalSizeMB }} MB
    </div>
    
    <!-- Add SMS file count indicator -->
    <div *ngIf="isSms" class="file-count-indicator" [class.error-text]="totalFileCount > maxFilePieces">
      {{ totalFileCount }} / {{ maxFilePieces }} files
    </div>
    
    <div *ngIf="!isValid" class="error-message">
      {{ validationError }}
    </div>
  </div>

  <div class="file-display" [class.expanded]="imageExpand">
    <!-- Dynamic files -->
    <div class="file-card" *ngFor="let file of currentFiles | slice: 0 : (imageExpand ? currentFiles.length : 4); let i = index">
      <div class="file-content">
        <!-- File type indicators and previews -->
        <div class="preview-container">
          <mat-icon *ngIf="!isImageFile(file) && !isVideoFile(file) && !isAudioFile(file)" [ngClass]="getFileIcon(file)">
            {{ getFileIcon(file) }}
          </mat-icon>
          <audio *ngIf="isAudioFile(file)" class="audio-preview" [src]="file.url" controls></audio>
          <img *ngIf="isImageFile(file)" [src]="file.url" class="file-preview" alt="Image preview" />
          <video *ngIf="isVideoFile(file)" [src]="file.url" controls class="file-preview"></video>
        </div>
        <div class="file-info">
          <span class="file-name" [matTooltip]="file.name || 'No Name Provided'">
            {{ file.name || 'No Name Provided' | truncate:20 }}
          </span>
          <!-- Add file size -->
          <span class="file-size" *ngIf="file.size">
            {{ file.size | fileSize }}
          </span>
        </div>
      </div>
      <button class="remove-btn" (click)="removeFile(i)" aria-label="Remove file">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Fixed files -->
    <div class="file-card" (click)="fileClick(file.cloud_key)"
      *ngFor="let file of currentFixedFiles | slice: 0 : (imageExpand ? currentFixedFiles.length : 4); let i = index">
      <div class="file-content">
        <!-- File type indicators and previews -->
        <div class="preview-container">
          <mat-icon *ngIf="file.type !== 'image' && file.type !=='video' && file.type !=='audio'" [ngClass]="getFileIcon(file)">
            {{ getFileIcon(file) }}
          </mat-icon>
          <audio *ngIf="file.type=='audio'" class="audio-preview" [src]="file.signUrl" controls></audio>
          <img *ngIf="file.type=='image'" [src]="file.signUrl" class="file-preview" alt="Image preview" />
          <video *ngIf="file.type=='video'" [src]="file.signUrl" controls class="file-preview"></video>
        </div>
        <div class="file-info">
          <span class="file-name" [matTooltip]="file.name || 'No Name Provided'">
            {{ file.name || 'No Name Provided' | truncate:20 }}
          </span>
          <!-- Add file size -->
          <span class="file-size" *ngIf="file.size">
            {{ file.size | fileSize }}
          </span>
        </div>
      </div>
      <button *ngIf="!isAlreadySent" class="remove-btn" (click)="removeSatic(i,file); $event.stopPropagation()" aria-label="Remove file">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Show more/less toggle button -->
    <button *ngIf="currentFiles?.length + currentFixedFiles?.length > 4" 
            class="expand-toggle" 
            (click)="togleImageExpand()" 
            aria-label="Show more files">
      <mat-icon>{{ imageExpand ? 'expand_less' : 'expand_more' }}</mat-icon>
      <span>{{ imageExpand ? 'Show less' : 'Show more' }}</span>
    </button>
  </div>
</div>